/**
 * A marca DECA, em imagem.
 *
 * ## Duas versões, e como a tela escolhe
 *
 * `deca.png` é a marca em preto (para fundo claro); `deca_dark.png`, em branco
 * (para fundo escuro). São as mesmas imagens do Deca 1, servidas de `public/logo`.
 *
 * O contrato de tema do app é a classe `escuro` no `<html>` (ver
 * `estilos/tokens.css`), **não** `prefers-color-scheme`: os tokens não seguem o
 * sistema operacional. Por isso a troca é por essa classe, com variante
 * arbitrária do Tailwind — um `<picture>` com `media="(prefers-color-scheme)"`
 * mostraria a marca branca numa tela clara para quem usa o sistema em modo
 * escuro, que é exatamente o caso do app hoje.
 *
 * Onde o fundo é escuro nos dois temas (a barra lateral), `fundo="escuro"` força
 * a versão branca: o tema da página não muda a cor da lateral.
 */
export function LogoDeca(props: {
  readonly fundo?: 'tema' | 'escuro';
  readonly className?: string;
}): JSX.Element {
  const altura = props.className ?? 'h-7';

  if (props.fundo === 'escuro') {
    return <img src="/logo/deca_dark.png" alt="Deca" className={`${altura} w-auto`} />;
  }

  return (
    <span className="inline-flex">
      <img src="/logo/deca.png" alt="Deca" className={`${altura} w-auto [.escuro_&]:hidden`} />
      {/* `display: none` some do leitor de tela também, então só uma das duas é lida. */}
      <img
        src="/logo/deca_dark.png"
        alt="Deca"
        className={`${altura} hidden w-auto [.escuro_&]:block`}
      />
    </span>
  );
}
